module.exports = __webpack_public_path__ + "img/DY.6f643c0e.png";